export const APP_VERSION = "v4.1";

export const DEFAULT_INTERNAL_DASHBOARD_URL =
  "https://transport.nex-automations.com";
export const DEFAULT_PUBLIC_QUOTE_URL = "https://quotes.nex-automations.com";
export const DEFAULT_PUBLIC_ONLY_HOSTS = ["quotes.nex-automations.com"];

const isProductionBuild = process.env.NODE_ENV === "production";

const splitHosts = (value) =>
  (value || "")
    .split(",")
    .map((host) => host.trim().toLowerCase().replace(/:\d+$/, ""))
    .filter(Boolean);

export const getPublicQuoteBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_PUBLIC_QUOTE_URL;
  const defaultUrl = isProductionBuild ? DEFAULT_PUBLIC_QUOTE_URL : "";

  return (configuredUrl ?? defaultUrl).replace(/\/$/, "");
};

export const getPublicOnlyHosts = () => {
  const configuredHosts = process.env.REACT_APP_PUBLIC_ONLY_HOSTS;
  const parsedHosts = splitHosts(configuredHosts);

  if (parsedHosts.length > 0) {
    return parsedHosts;
  }

  return isProductionBuild ? DEFAULT_PUBLIC_ONLY_HOSTS : [];
};

export const isPublicOnlyHost = (host) => {
  const normalizedHost = (host || "").toLowerCase().replace(/:\d+$/, "");
  return getPublicOnlyHosts().includes(normalizedHost);
};
